import React, { Component } from "react";
import { message } from "antd";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";
import englishData from "./utils/language/leStudy/english.json";
import spanishData from "./utils/language/leStudy/spanish.json";

export default class AutoLogin extends Component {
  componentDidMount() {
    const urlString = window.location.href;
    // Create a URL object
    const url = new URL(urlString);
    // Get the value of the 'token' query parameter
    const token = url.searchParams.get("auth_token");
    const participants_accounts_id = url.searchParams.get("participants_accounts_id");
    this.auto_login(token, participants_accounts_id);
    if (!token) {
      // window.location.assign("/");
      return;
    }
  }
  auto_login = (token, participants_accounts_id) => {
    let param = "?auth_token=" + token + '&research_type=' + RESEARCH_TYPE + '&participants_accounts_id=' + participants_accounts_id;
    Bridge.authoriseAutoLoginUser(param)
      .then((res) => {
        // Get language from response or localStorage, default to English
        const language = res.language || localStorage.getItem("ap_language") || "English";
        const formData = language === "Spanish" ? spanishData : englishData;

        if (res.status == "1") {
          localStorage.setItem("aptoken", res.token);
          localStorage.setItem("ap_name", res.first_name ? res.first_name : "User");
          localStorage.setItem("ap_id", res.participants_id);
          localStorage.setItem("ap_eals_id", res.eals_id);
          localStorage.setItem("user_type", RESEARCH_TYPE);
          localStorage.setItem("ap_participants_accounts_id", res.participants_accounts_id);
          localStorage.setItem("ap_language", res.language);
          localStorage.setItem(
            "ap_relation_to_als",
            res.relation_to_als
          );
          if (res.date_created) {
            localStorage.setItem("ap_date_created", res.date_created);
          }
          message.success(formData.page.signIn.messages.loginSuccess);

          if (res.consent_form_status == false) {
            window.location.assign("/consent-form");
          } else {
            window.location.assign("/dashboard");
          }
          return;
        } else {
          message.warning(formData.apiMessages.invalidToken);
          // window.location.assign("/");
        }
      })
      .catch((err) => {
        // Get language from localStorage, default to English
        const language = localStorage.getItem("ap_language") || "English";
        const formData = language === "Spanish" ? spanishData : englishData;
        message.warning(formData.apiMessages.somethingWentWrongPleaseTryAgain);
        // window.location.assign("/");
      });
  };
  render() {
    return (
      <div className="container-fluid bg-white" style={{ minHeight: "100vh" }}>
        <div className="row">
          <div className="col-lg-4 m-auto">
            <div className="loader-section bg-white">
              <div className="inner text-center" style={{ paddingTop: 100 }}>
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <img
                    src={"./assets/images/auto-login-assets/main-logo.png"}
                    className="logo-img mb-4 mt-4"
                    style={{ maxWidth: 180 }}
                  />
                  <img
                    src={"./assets/images/auto-login-assets/loader.gif"}
                    className="loader"
                    style={{ maxWidth: 60 }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
